import { InfoOutlined } from "@mui/icons-material";
import { Button, Tooltip, TooltipProps, Typography, TypographyProps } from "@mui/material";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import palette from "theme/palette";
import { LabelLink } from "./types";

interface FieldLabelProps {
  label: ReactNode;
  labelLink?: LabelLink;
  required?: boolean;
  disabled?: boolean;
  horizontalMode?: boolean;
  typographyProps?: TypographyProps;
  tooltipProps?: Omit<TooltipProps, "children">;
}

const FieldLabel = ({
  label,
  labelLink,
  required,
  disabled,
  horizontalMode,
  typographyProps,
  tooltipProps,
}: FieldLabelProps) => {
  const { text, ...restLabelLink } = labelLink || {};
  const { sx: typographySx, ...restTypographyProps } = typographyProps || {};

  return (
    <Typography
      variant='body14rg'
      sx={{ color: palette.base[500], ...(horizontalMode && { whiteSpace: "nowrap" }), ...typographySx }}
      {...restTypographyProps}>
      {label}
      <Typography
        component='span'
        variant='body14rg'
        sx={{ color: palette.error.main, ...((disabled || !required) && { visibility: "hidden", opacity: 0 }) }}>
        {` *`}
      </Typography>
      {tooltipProps && (
        <Tooltip {...tooltipProps}>
          <InfoOutlined
            color='primary'
            sx={{ verticalAlign: "middle" }}
          />
        </Tooltip>
      )}
      {labelLink && (
        <Button
          variant='text'
          component={Link}
          {...restLabelLink}>
          {text}
        </Button>
      )}
    </Typography>
  );
};

export default FieldLabel;
